import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export class ContractorsDetailRequest extends GenericRequest {

    request;

    constructor(id) {
        super(METHOD_GET, RouterUtils.generateRoute(ApiEndpoints.CONTRACTORS_DETAIL, { id }));
        this.request = {};
    }

    overrideRequest() {
        return this.request;
    }

}




// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsDetailRequest.js